import { Flex, KpiSkeleton, KpiCard } from '@blockanalitica/ui';
import { useApi } from '@/api';

type OverviewData = {
  supply: string | null;
  supply_change: string | null;
  supply_change_percentage: string | null;
  borrow: string | null;
  borrow_change: string | null;
  borrow_change_percentage: string | null;
  collateral: string | null;
  collateral_change: string | null;
  collateral_change_percentage: string | null;
};

export default function OverviewKpis() {
  const [data, error] = useApi<OverviewData>({
    url: '/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
        <KpiSkeleton />
        <KpiSkeleton />
        <KpiSkeleton />
      </Flex>
    );
  }

  return (
    <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
      <KpiCard
        title="Total Earning"
        data={data}
        field="supply"
        options={{
          valueOptions: {
            currencyValueOptions: {
              currency: 'USD',
              notation: 'compact'
            }
          }
        }}
      />
      <KpiCard
        title="Total Borrowing"
        data={data}
        field="borrow"
        options={{
          valueOptions: {
            currencyValueOptions: {
              currency: 'USD',
              notation: 'compact'
            }
          }
        }}
      />
      <KpiCard
        title="Total Collateral"
        data={data}
        field="collateral"
        options={{
          valueOptions: {
            currencyValueOptions: {
              currency: 'USD',
              notation: 'compact'
            }
          }
        }}
      />
    </Flex>
  );
}
